import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import ContactButton from './components/ContactButton/ContactButton';
import Home from './pages/Home/Home';
import Pricing from './components/Pricing/Pricing';
import './styles/global.scss';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
        </Routes>
        <ContactButton />
      </div>
    </Router>
  );
}

export default App;

